import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardMedia, Typography, Grid, CircularProgress, Alert, Button, Snackbar } from '@mui/material';
import { CartContext } from '../context/CartContext';

function ProductList() {
  const { addToCart } = useContext(CartContext);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  useEffect(() => {
    fetch('/api/products')
      .then(res => {
        if (!res.ok) {
          throw new Error('Network response was not ok');
        }
        return res.json();
      })
      .then(data => {
        setProducts(data);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
        console.error('Error fetching products:', err);
      });
  }, []);

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    return <Alert severity="error">Error fetching products: {error}</Alert>;
  }

  return (
      <Grid container spacing={4}>
        {products.map(product => (
            <Grid key={product.id} size={{ xs: 12, sm: 6, md: 4 }}>
              <div>
                <Link to={`/product/${product.id}`} style={{ textDecoration: 'none' }}>
                  <Card>
                    <CardMedia
                        component="img"
                        height="140"
                        image={product.itemData.imageUrl}
                        alt={product.itemData.name}
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        {product.itemData.name}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {new Intl.NumberFormat('en-US', {
                          style: 'currency',
                          currency:
                          product.itemData.variations[0].itemVariationData.priceMoney.currency
                        }).format(
                            product.itemData.variations[0].itemVariationData.priceMoney.amount / 100
                        )}
                      </Typography>
                    </CardContent>
                  </Card>
                </Link>

                <Button
                    onClick={() => {
                      addToCart(product);
                      setSnackbarOpen(true);
                    }}
                    variant="contained"
                    color="primary"
                    fullWidth
                >
                  Add to Cart
                </Button>
              </div>
            </Grid>
        ))}

        <Snackbar
            open={snackbarOpen}
            autoHideDuration={3000}
            onClose={() => setSnackbarOpen(false)}
            message="Item added to cart"
        />
      </Grid>
  );
}

export default ProductList;
